import { TopUpInfo } from '@interfaces'
import { api } from '@utils/api/api'

export const getInfoTopUp = (): Promise<TopUpInfo> => {
  return api.get('/api/v1/payments/top-up/info')
}
